import styled from 'styled-components';
import { PRIMARY_COLOR_1, FILE_BLUE } from '../../../appearance/Colors';

export const GalleryPreviewGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
    gap: 4px;
    width: 100%;
    min-width: 0;
    max-height: 250px;
    overflow-y: auto;
`;

export const GalleryPreviewItem = styled.button`
    position: relative;
    width: 100%;
    min-width: 0;
    min-height: 0;
    aspect-ratio: 1;
    padding: 0;
    overflow: hidden;
    border: 0;
    border-radius: 6px;
    background: ${PRIMARY_COLOR_1};
    cursor: pointer;

    /* The square button determines row height. Keep image intrinsic dimensions
       and percentage heights out of the grid's automatic row-size calculation. */
    img {
        position: absolute;
        inset: 0;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:focus-visible {
        outline: 2px solid ${FILE_BLUE};
        outline-offset: 2px;
    }
`;
